export default {"src":"/_next/static/media/0x0eb3a705fc54725037cc9e008bdede697f62f335.0c1e1979.svg","height":2500,"width":2500,"blurWidth":0,"blurHeight":0};